import { useStoreConfig } from '@/contexts/StoreConfigContext';

export default function AnnouncementBar() {
  const { config } = useStoreConfig();

  const messages = config?.announcement_messages?.length
    ? config.announcement_messages.slice(0, 3)
    : ['FREE SHIPPING ON ALL ORDERS', '30-DAY MONEY BACK GUARANTEE', 'SECURE CHECKOUT'];

  const joinedText = messages.join('  \u2726  ');
  const repeated = `${joinedText}  \u2726  ${joinedText}  \u2726  ${joinedText}  \u2726  `;

  return (
    <div data-testid="announcement-bar" className="overflow-hidden select-none" style={{ backgroundColor: '#000', height: 34 }}>
      <div className="h-full flex items-center">
        <div className="whitespace-nowrap animate-marquee" style={{ animationDuration: '35s' }}>
          <span className="font-sans uppercase" style={{ color: '#fff', fontSize: '11px', letterSpacing: '0.15em' }}>
            {repeated}
          </span>
        </div>
      </div>
      <style>{`
        @keyframes marquee { 0% { transform: translateX(0%); } 100% { transform: translateX(-33.33%); } }
        .animate-marquee { animation: marquee linear infinite; will-change: transform; }
      `}</style>
    </div>
  );
}
